import type { PropsWithChildren } from 'react';
import { useMemo } from 'react';

import { AppContext } from './app-context';
import useServiceFetchCycler from './use-service-fetch-cycler';

export const AppProvider = ({
  children,
  ...data
}: PropsWithChildren<AppData>) => {
  const serviceCycler = useServiceFetchCycler();

  const context = useMemo(
    () => ({
      ...data,
      serviceCycler,
    }),
    [data, serviceCycler],
  );

  return <AppContext.Provider value={context}>{children}</AppContext.Provider>;
};

export default AppProvider;
